import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import ToolActionButtons from "../../Components/ToolActionButtons";
import { Row, Col } from "react-bootstrap";
import { useState } from "react";
import { HashCompute } from "../../Services/APIService";
import FormatterPanel from "../../HomePage/FormatterPanel";
import { InputHeaderButtons, OutputHeaderButtons } from "../JSONTools/JSONToolsHeaderButtons";


function HashGenerator() {
    const [text, setText] = useState("");
    const [result, setresult] = useState("")
    const toolFav = { toolName: 'Hash Generator', Iconpath: "/FileCodeRaw.svg" };
    const [activeAction, setActiveAction] = useState({ "name": "SHA-1", "value": "sha1" });


    const lineCount = text !== "" ? (text || "").split("\n").length : 0;
    const resultLineCount = result !== "" ? (result ?? "").toString().split("\n").length : 0;

    const handleChange = (e) => {
        setText(e.target.value);
    };


    const CalculateHash = async () => {
        try {
            const response = await HashCompute({ input: text }, activeAction.value);
            setresult(response.data.hash);
        } catch (error) {
            setresult("Error generating hash: " + error.message);
        }
    }

    const handleImport = (filecontent) => {
        setText(filecontent);
    };


    const runAction = async (action) => {
        setActiveAction(action);
        setText("");
        setresult("");
    }
    return (
        <>
            <Col>
                <ToolHeader title="Hash Generator" description="Generate hashes for your data" toolFav={toolFav} />

                <ToolActionButtons
                    actions={[
                        { name: "MD5", value: "md5" },
                        { name: "SHA-1", value: "sha1" },
                        { name: "SHA-256", value: "sha256" },
                        { name: "SHA-512", value: "sha512" }
                    ]}
                    activeValue={activeAction.value}
                    onAction={runAction}
                />

               <Row className='Formatter json-formatter-row'>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Input"
                            value={text}
                            onChange={(e) => handleChange(e)}
                            placeholder="Paste your text here..."
                            lineCount={lineCount}
                            headerButtons={
                                <InputHeaderButtons
                                    onClear={() => {
                                        setText("");
                                        setresult("");
                                    }}
                                    onImport={(fileContent) => handleImport(fileContent)}
                                    accept=".txt,.json"
                                    executeLabel={"Format"}
                                    showExecute={true}
                                    onExecute={CalculateHash}
                                />
                            }
                            footerLeft={`Characters : ${text.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([text]).size} B`}
                        />
                    </Col>
                    <Col xs={12} lg={6} className="json-formatter-column">
                        <FormatterPanel
                            title="Formatted output"
                            value={result ?? ""}
                            placeholder={`${activeAction.name} hash will appear here..`}
                            lineCount={resultLineCount}
                            readOnly
                            headerButtons={
                                <OutputHeaderButtons
                                    outputText={result ?? ""}
                                    fileName="formatted.txt"
                                    mimeType="text/plain;charset=utf-8"
                                />
                            }
                            footerLeft={`Characters : ${result.replaceAll(" ", "").length}`}
                            footerRight={`Size : ${new Blob([result ?? ""]).size} B`}
                        />
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default HashGenerator;
